export default __webpack_public_path__ + "img/settings-arrow.6ff7cd11.svg";